(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader) return;

  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  const searchDetails = sectionHeader.querySelector('details-modal details');
  const disclosureButtons = sectionHeader.querySelectorAll('.disclosure__button');
  const cartDrawer = document.querySelector('cart-drawer');
  const cartDrawerInner = cartDrawer ? cartDrawer.querySelector('.drawer__inner') : null;
    const announcementBar = document.querySelector('.announcement-bar-section');

  const updateHeaderStackHeight = () => {
    const headerHeight = sectionHeader.offsetHeight;
    let announcementVisibleHeight = 0;

    if (announcementBar && window.getComputedStyle(announcementBar).display !== 'none') {
      const rect = announcementBar.getBoundingClientRect();
      announcementVisibleHeight = Math.max(0, Math.min(rect.bottom, rect.height));
    }

    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementVisibleHeight}px`);
    document.documentElement.style.setProperty(
      '--header-total-height',
      `${headerHeight + announcementVisibleHeight}px`
    );
  };

  let cartWasOpen = cartDrawer ? cartDrawer.classList.contains('active') : false;
  let cartClosePending = false;

  const getDisclosureOpen = () =>
    Array.from(disclosureButtons).some((button) => button.getAttribute('aria-expanded') === 'true');

  const getState = () => {
    const drawerOpen = drawerDetails ? drawerDetails.hasAttribute('open') : false;
    const searchOpen = searchDetails ? searchDetails.hasAttribute('open') : false;
    const disclosureOpen = getDisclosureOpen();
    const cartOpen = cartDrawer ? cartDrawer.classList.contains('active') : false;

    return {
      drawerOpen,
      searchOpen,
      disclosureOpen,
      cartOpen,
      otherUiOpen: drawerOpen || searchOpen || disclosureOpen,
    };
  };

  const applyHeaderState = (isOpen, drawerOpen) => {
    sectionHeader.classList.toggle('header-ui-open', isOpen);
    sectionHeader.classList.toggle('header-drawer-open', drawerOpen);
  };

  const syncHeaderUiState = () => {
    updateHeaderStackHeight();
    const { drawerOpen, cartOpen, otherUiOpen } = getState();

    if (cartOpen) {
      cartWasOpen = true;
      cartClosePending = false;
      applyHeaderState(true, drawerOpen);
      return;
    }

    if (cartWasOpen && !cartOpen && !otherUiOpen) {
      cartWasOpen = false;
      cartClosePending = true;
      applyHeaderState(true, drawerOpen);
      return;
    }

    if (cartClosePending && !otherUiOpen) {
      applyHeaderState(true, drawerOpen);
      return;
    }

    cartWasOpen = false;
    cartClosePending = false;
    applyHeaderState(otherUiOpen, drawerOpen);
  };

  if (drawerDetails) {
    drawerDetails.addEventListener('toggle', syncHeaderUiState);
  }

  if (searchDetails) {
    searchDetails.addEventListener('toggle', syncHeaderUiState);
  }

  disclosureButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(syncHeaderUiState, 0);
    });
  });

  if (cartDrawer) {
    const cartObserver = new MutationObserver(syncHeaderUiState);
    cartObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (cartDrawerInner) {
    cartDrawerInner.addEventListener('transitionend', (event) => {
      if (event.propertyName !== 'transform') return;

      const { drawerOpen, cartOpen, otherUiOpen } = getState();

      if (!cartOpen && !otherUiOpen) {
        cartClosePending = false;
        applyHeaderState(false, drawerOpen);
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (!drawerDetails || !drawerDetails.hasAttribute('open')) {
      setTimeout(syncHeaderUiState, 0);
      return;
    }

    const clickedInsideDrawer = event.target.closest('#menu-drawer');
    const clickedMenuButton = event.target.closest('#Details-menu-drawer-container > summary');

    if (!clickedInsideDrawer && !clickedMenuButton) {
      drawerDetails.removeAttribute('open');
      const summary = drawerDetails.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    setTimeout(syncHeaderUiState, 0);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawerDetails && drawerDetails.hasAttribute('open')) {
      drawerDetails.removeAttribute('open');
      const summary = drawerDetails.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      }
      syncHeaderUiState();
    }
  });

  window.addEventListener('scroll', updateHeaderStackHeight, { passive: true });
  window.addEventListener('resize', updateHeaderStackHeight);

  updateHeaderStackHeight();
  syncHeaderUiState();
});

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
